const getters = {
  info: state => state.user.info,
  isWeixin: state => state.user.isWeixin,
  accountInfo: state => state.user.accountInfo,
  hasLogin: state => state.user.hasLogin
};
export default getters;
